import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from '../styles/hero.module.scss';

import type { IHeroGrid } from '../types';

const HeroGrid = ({
  children, hasForm, hasImage, hasMedia, imageType, embeddedForm, textAlignment,
}: IHeroGrid) => {
  if (!hasMedia && embeddedForm === 'none') {
    return <div className={generateClassName(['grid', styles.textHeroGrid, textAlignment === 'center' ? styles.center : ''])}>{children}</div>;
  }

  if (imageType === 'horizontal' && embeddedForm === 'none') {
    return <div className={generateClassName(['grid', styles.horizontalHeroGrid, textAlignment === 'center' ? styles.center : ''])}>{children}</div>;
  }

  return (
    <>
      <div className={generateClassName([
        'grid',
        styles.verticalHeroGrid,
        hasForm ? styles.hasForm : '',
        hasImage ? styles.hasImage : '',
      ])}>
        {children}
      </div>
    </>
  );
};

export default HeroGrid;
